export class TestNotFoundException extends Error {
  name = "TestNotFoundException";
  message = "That test could not be found";
}
